module.exports = __webpack_public_path__ + "static/media/upload.82b341ce.svg";